const initialState = () => ({ ...window.APP_CONFIG });

export default {
  namespaced: true,

  state() {
    return initialState();
  },
};
